import Actions from 'actions';

const initialState = Object.freeze({});

function profile(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_PROFILE_SUCCESS:
    case Actions.UPDATE_USER_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_PROFILE_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default profile;
